/* unplugin-vue-components disabled */import script from "./materialDailog.vue?vue&type=script&setup=true&lang=js"
export * from "./materialDailog.vue?vue&type=script&setup=true&lang=js"

import "./materialDailog.vue?vue&type=style&index=0&id=9ae7d7a8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ae7d7a8"]])

export default __exports__